import { render, staticRenderFns } from "./PaymentCardsBlock.vue?vue&type=template&id=7634b496"
import script from "./PaymentCardsBlock.vue?vue&type=script&lang=js"
export * from "./PaymentCardsBlock.vue?vue&type=script&lang=js"
import style0 from "./PaymentCardsBlock.vue?vue&type=style&index=0&id=7634b496&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports